<template>
  <v-app>
    <v-navigation-drawer fixed
                         v-model="isCollapse"
                         app
                         width="250">
      <navigation-sidebar :is-collapse="false"></navigation-sidebar>
    </v-navigation-drawer>

    <v-toolbar color="white"
               fixed
               height="64"
               app>
      <v-toolbar-side-icon @click.stop="isCollapse = !isCollapse"></v-toolbar-side-icon>
      <v-toolbar-title v-if="parkingId !== 0">
        <router-link :to="{ name: 'ParkingHome', params: {id: parkingId} }"> {{title}}
        </router-link>
      </v-toolbar-title>
      <v-toolbar-title v-else>{{title}}</v-toolbar-title>
      <v-spacer>
      </v-spacer>
      <user-details-dropdown></user-details-dropdown>
      <change-language-dropdown :show-flag-country="true"></change-language-dropdown>
    </v-toolbar>

    <v-content v-resize="onResize"
               id="content">
      <router-view :key="$route.fullPath"></router-view>

      <dps-footer></dps-footer>
    </v-content>

    <v-snackbar :timeout="snackbar.timeout"
                :right="snackbar.right"
                :top="snackbar.top"
                v-model="snackbar.visible"
                :color="snackbar.color">
      {{ snackbar.text }}
      <v-btn dark
             flat
             @click.native="snackbar.visible = false"><v-icon>close</v-icon></v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import store from '@/store';
import keys from '@/store/keys';
import ChangeLanguageDropdown from '@/components/commons/ChangeLanguageDropdown.vue';
import UserDetailsDropdown from '@/components/commons/UserDetailsDropdown.vue';
import NavigationSidebar from '@/components/commons/NavigationSidebar.vue';
import { EventBus } from '@/services/eventBus';
import DpsFooter from '@/components/commons/Footer';
import _ from 'lodash';

export default {
  name: 'dashboard-layout',
  components: {
    [ChangeLanguageDropdown.name]: ChangeLanguageDropdown,
    [UserDetailsDropdown.name]: UserDetailsDropdown,
    [NavigationSidebar.name]: NavigationSidebar,
    [DpsFooter.name]: DpsFooter
  },
  beforeRouteEnter(to, from, next) {
    if (!store.state.isLogged) {
      next('/login');
      return;
    }
    next();
  },
  created() {
    this.lastDisplaySize = this.getDisplaySize();

    EventBus.$on(keys.eventOnShowNotification, this.showNotification);
    EventBus.$on(keys.eventOnParkingSelected, this.updateDashboardTitle);
  },
  destroyed() {
    EventBus.$off(keys.eventOnShowNotification, this.showNotification);
    EventBus.$off(keys.eventOnParkingSelected, this.updateDashboardTitle);
  },
  data() {
    return {
      isCollapse: true,
      title: '',
      parkingId: 0,
      snackbar: {
        text: '',
        visible: false,
        timeout: 3000,
        right: true,
        top: true
      },
      lastDisplaySize: '',
      currentDisplaySize: ''
    };
  },
  methods: {
    getDisplaySize() {
      if (this.$vuetify.breakpoint.xs) {
        return 'xs';
      } else if (this.$vuetify.breakpoint.sm) {
        return 'sm';
      } else if (this.$vuetify.breakpoint.md) {
        return 'md';
      } else if (this.$vuetify.breakpoint.lg) {
        return 'lg';
      } else if (this.$vuetify.breakpoint.xl) {
        return 'xl';
      }
    },
    onResize() {
      this.currentDisplaySize = this.getDisplaySize();
      if (typeof this.lastDisplaySize === 'undefined') {
        this.lastDisplaySize = this.getDisplaySize();
      } else if (this.lastDisplaySize !== this.currentDisplaySize) {
        store.commit('ON_WINDOWS_RESIZE', { from: this.lastDisplaySize, to: this.currentDisplaySize });
        this.lastDisplaySize = this.currentDisplaySize;
      }
    },
    toggleSidebar() {
      this.isCollapse = !this.isCollapse;
    },
    showNotification(data) {
      if (data.doNotTranslate) {
        this.snackbar.text = data.message;
      } else {
        this.snackbar.text = this.$i18n.t(data.message, data.messageParams);
      }
      this.snackbar.color = data.type;
      this.snackbar.visible = true;
    },
    updateDashboardTitle(data) {
      if (data.parking === null) {
        this.title = 'Dashboard';
        this.parkingId = 0;
        return;
      }
      this.title = data.parking.name;
      let parkingSelected = _.find(store.state.parkingList, itParking => {
        return itParking.name === data.parking.name;
      });

      if (typeof parkingSelected !== 'undefined') {
        this.parkingId = parkingSelected.id;
      } else {
        this.parkingId = 0;
      }
    }
  }
};
</script>

<style lang="scss">
@import '~@/assets/sass/dps-customization.scss';

a.capitalize {
  text-transform: capitalize !important;
}
#content {
  background-color: white !important;
  padding-top: 74px !important;
}
</style>


<style lang="scss" scoped>
.menu-bars {
  font-size: 20px;
  text-align: left;
  background: transparent;
  border: 0px solid #efefef;
  color: #7e7e7e;
}

.full-body {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  position: relative;
}

.container.grid-list-md {
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/DashboardLayout.vue